import { initGoogleMapsLoader } from "./google_maps_loader.js"
import $ from "jquery"

var autocomplete;
function init_autocomplete(){
  initGoogleMapsLoader().then(() => {
    var defaultBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(82.16, 40.22),
      new google.maps.LatLng(27.49, -31.46)
    );

    var input = document.getElementsByClassName('autocomplete_places')[0];
    var options = {
      bounds: defaultBounds,
      types: ['(cities)'],
      language: I18n.currentLocale(),
    };
    autocomplete = new google.maps.places.Autocomplete(input, options);
    autocomplete.setFields(['address_component']);
    autocomplete.addListener('place_changed', fillInCity);
  });
}

function fillInCity(){
  var place = autocomplete.getPlace();
  let name = place.address_components[0] && place.address_components[0].long_name || ''
  document.getElementsByClassName('autocomplete_places')[0].value = name;
}

document.addEventListener("turbolinks:load", () => {
  if($(".autocomplete_places").length > 0){
    init_autocomplete();
  }
})
